module.exports = __webpack_public_path__ + "static/media/Character3.2718d02b.png";